export const PROCESSING_CLAIMS = "PROCESSING_CLAIMS";
export const GET_CLAIMS_DATA = "GET_CLAIMS_DATA";
export const CREATE_CLAIM = "CREATE_CLAIM";
export const DELETE_CLAIM = "DELETE_CLAIM";
export const ADD_CLAIM_COMMENT = "ADD_CLAIM_COMMENT";
